import EdoTechnicalAssistance from "./EdoTechnicalAssistance";

export default EdoTechnicalAssistance;
